module.exports = __webpack_public_path__ + "static/media/hot_srrx.931a9335.png";